// --- getVerbSingularPluralEnding

export default function getVerbSingularPluralEnding ( number ) {
    return number === 1
        ? "s"
        : ""
}